import { FormLabel } from '@mui/material';
import { PropsWithChildren } from 'react';
import { SxProps } from '@mui/system';
import { mergeSx } from '../../utils/material-ui';

const FormSectionTitle = ({
    children,
    sx,
}: PropsWithChildren<{ sx?: SxProps }>) => {
    return (
        <FormLabel
            sx={[{ typography: 'h5', color: 'text.primary' }, ...mergeSx(sx)]}
        >
            {children}
        </FormLabel>
    );
};

export default FormSectionTitle;
